<div class="outer-container" *ngIf="allowed; else notAllowed">
  <div class="card d-flex fd-col jc-between ai-stretch">
    <div class="lookup-container">
      <div class="flex-container d-flex fd-row ai-center">
        <div class="description">Tender notice number lookup:</div>
        <div class="input-container">
          <input mat-input type="text" [formControl]="referenceId" class="lookupField" />
          <button
            class="save-button flex-1"
            mat-flat-button
            color="primary"
            (click)="lookupItem()"
            [disabled]="!referenceId.value || referenceId.value.length == 0"
          >
            <mat-icon>search</mat-icon>
            Search
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #notAllowed>
  <!-- <div class="flex-1 d-flex jc-between ai-center card not-allowed-message">
        <div>
            <b>This feature is available for paid {{tileInstance.dataSourceAlias}} subscribers.</b>
        </div>

        <button color="primary" mat-stroked-button routerLink="/private/my-account/subscription">View upgrade
            options</button>
    </div> -->
</ng-template>
